// On phones the register tables render as cards, and each cell shows its column name through
// `td::before { content: attr(data-label) }`. Tables written with explicit data-label attributes are left alone;
// this fills the gaps for tables marked `mobile-cards` by copying the header text of the matching column.
export function labelCardTables(root = document) {
  root.querySelectorAll("table.mobile-cards").forEach((table) => {
    const headers = [...table.querySelectorAll("thead th")].map((header) => header.textContent.trim());
    table.querySelectorAll("tbody tr").forEach((row) => {
      let column = 0;
      [...row.children].forEach((cell) => {
        const label = headers[column];
        if (cell.colSpan === 1 && label && !cell.hasAttribute("data-label")) cell.setAttribute("data-label", label);
        column += cell.colSpan || 1;
      });
    });
  });
}

// Keeps newly rendered rows labelled. Returns a function that stops watching.
export function watchCardTables(root = document.body) {
  if (typeof MutationObserver === "undefined" || !root) return () => {};
  let queued = false;
  const run = () => {
    queued = false;
    labelCardTables(root);
  };
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  });
  observer.observe(root, { childList: true, subtree: true });
  run();
  return () => observer.disconnect();
}
